import api from './api';
import { Login, LoginResponse, PasswordRecovery, PasswordReset, Response, User } from '../dtos';

const authenticate = async (dto: Login): Promise<LoginResponse> => {
    const { data } = await api.post<LoginResponse>('login', dto);
    return data;
};

const getUserDetails = async (): Promise<User> => {
    const { data } = await api.get<Response<User>>('users/details');
   
    return data.data;
};

const resetPassword = async (dto: PasswordReset): Promise<void> => {
    await api.patch<void>('users/password', dto);
};

const recoverPassword = async (dto: PasswordRecovery): Promise<void> => {
    await api.patch<void>('users/password-recovery', dto);
};

const updatePhoneNumber = async (phoneNumber?: string): Promise<void> => {
    await api.patch<void>('users/phoneNumber', {
        phoneNumber
    });
};

export { authenticate, getUserDetails, resetPassword, recoverPassword, updatePhoneNumber };